// extracted by mini-css-extract-plugin
export default {"explainationContent":"styles_explainationContent__pwAJM"};